import { createElement, memo, useEffect, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import { ALL_MOCK_SCENES, MOCK_SCENE_LABELS, resolveActiveScene, setActiveMockScene, subscribeMockScene } from '../../mock';
import './index.scss';
// 开发期 mock 场景切换面板（仅在 mock 模式生效）：
// 当前生效场景由模块级变量 resolveActiveScene() 决定（非 mock 模式 = undefined → 不渲染，线上零侵入）。
// 切换：直接 setActiveMockScene(场景)（纯变量切换，不刷新页面、不改 URL）；
// 数据 hook 订阅了场景变更会自动重新拉取，面板这里订阅后重渲染以高亮新场景。
function MockSceneSwitcher() {
    const [active, setActive] = useState(resolveActiveScene());
    const [open, setOpen] = useState(false);
    // 订阅场景变更：切换后同步面板当前态（fab 文案 + 高亮）
    useEffect(() => subscribeMockScene(() => setActive(resolveActiveScene())), []);
    // 非 mock 模式不展示（线上 DEV_MOCK_SCENE=undefined → 不渲染）
    if (!active)
        return null;
    function switchTo(scene) {
        setOpen(false);
        setActiveMockScene(scene); // 纯变量切换，触发数据 hook 重新拉取
    }
    return <View className="mock-switcher">
      
      <View x-if={open} className="mock-switcher__panel">
        <ScrollView className="mock-switcher__list" showsVerticalScrollIndicator={false}>
          {ALL_MOCK_SCENES.map(scene => <Button key={scene} className={scene === active ? 'mock-switcher__item mock-switcher__item--active' : 'mock-switcher__item'} onPress={() => switchTo(scene)}>
              <Text className="mock-switcher__item-text" numberOfLines={1}>
                {MOCK_SCENE_LABELS[scene]}
              </Text>
            </Button>)}
        </ScrollView>
      </View>
      
      <Button className="mock-switcher__fab" onPress={() => setOpen(v => !v)}>
        <Text className="mock-switcher__fab-text" numberOfLines={1}>
          {`🧪 ${MOCK_SCENE_LABELS[active]}`}
        </Text>
      </Button>
    </View>;
}
export default memo(MockSceneSwitcher);
